<template>
    <q-header class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
        <q-toolbar style="justify-content: space-between; padding:0 2vw">
            <div style="height: 7.17vmin; display: flex; align-items: center;">
                <q-icon name="img:/assets/images/icon/ico_back.svg" :onclick="onClickBack" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                <div class="header_lesson q-px-sm b1">
                    <b>{{ props.title }}</b>
                </div>
            </div>
            <div style="go-home">
                <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
            </div>
        </q-toolbar>
    </q-header>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { DialogStore } from '@/store/modules/dialog';
import { useQuasar } from 'quasar';

const router = useRouter();
const $q = useQuasar();
const store = DialogStore();

const props = defineProps({
    title: '',
    path: {
        default: null,
    },
});

const emit = defineEmits(['onClickBack']);

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
    // $q.dialog({
    //     title: '확인',
    //     message: '홈으로 이동하시겠습니까?',
    //     cancel: true,
    //     persistent: true
    // }).onOk(() => {
    //     checkConfirm(true);
    // }).onCancel(() => {
    //     // console.log('>>>> Cancel')
    // })
};

const onClickBack = () => {
    if (emit('onClickBack')) {
        emit('onClickBack');
    } else if (props?.path) {
        router.push('/' + props.path);
    } else {
        window.history.back();
    }
};
</script>

<style scoped lang="scss">

</style>
